import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  CircularProgress,
  Typography,
  Backdrop,
} from '@mui/material';
import color from 'utils/colors';

function UploadLoadingOverlay({ open, message }) {
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (open) {
        const warningMessage = 'Si cierras esta pestaña, los archivos no serán subidos. ¿Estás seguro de que quieres continuar?';
        event.preventDefault();
        event.returnValue = warningMessage;
        return warningMessage;
      }
    };

    if (open) {
      window.addEventListener('beforeunload', handleBeforeUnload);
    } else {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [open]);
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
      }}
      open={open}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          p: 4,
          borderRadius: 2,
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          minWidth: 600,
          minHeight: 250,
        }}>
        <Box
          sx={{
            display: 'inline-flex',
            mb: 3,
          }}>
          <CircularProgress
            size={50}
            thickness={4}
            sx={{
              color: color.purpleSecondary,
              '& .MuiCircularProgress-circle': {
                strokeLinecap: 'round',
              },
            }}
          />
        </Box>
        
        <Typography
          variant="h5"
          sx={{
            fontWeight: '600',
            color: '#343A40',
            mb: 2,
            fontSize: 24,
            letterSpacing: '0.1em',
          }}>
          Procesando Archivos
        </Typography>
        
        <Typography
          variant="body1"
          sx={{
            color: '#000',
            mb: 1,
            fontSize: 16,
            lineHeight: 1.5,
          }}>
          {message || 'Procesando y subiendo archivos del documento'}
        </Typography>
        
        <Typography
          variant="body2"
          sx={{
            color: '#777',
            fontSize: 14,
          }}>
          Por favor, no cierre esta ventana
        </Typography>
      </Box>
    </Backdrop>
  );
}

UploadLoadingOverlay.propTypes = {
  open: PropTypes.bool.isRequired,
  message: PropTypes.string,
};

UploadLoadingOverlay.defaultProps = {
  message: '',
};

export default UploadLoadingOverlay;